<template>
  <div class="md-layout text-center">
    <notifications></notifications>
    <div
      class="
        md-layout-item
        md-size-66
        md-medium-size-66
        md-small-size-90
        md-xsmall-size-100
      "
    >
      <!--  header-color="blue" -->
      <login-card> 
        <!-- <p slot="description" class="description">Or Be Classical</p> -->
        <md-field class="md-form-group" slot="inputs">
          <md-icon>face</md-icon>
          <label>{{$I18n("user_id")}}</label>
          <md-input v-model="firstname"></md-input>
        </md-field>
        <!-- <md-field class="md-form-group" slot="inputs">
          <md-icon>email</md-icon>
          <label>Email...</label>
          <md-input v-model="email" type="email"></md-input>
        </md-field> -->
        <md-field class="md-form-group" slot="inputs">
          <md-icon>lock_outline</md-icon>
          <label>{{$I18n("password")}}</label>
          <md-input v-model="password" type="password"></md-input>
        </md-field>
        <md-button slot="footer" class="diy-submit md-info md-round" @click="submit">
          {{$I18n("login")}}
        </md-button>
      </login-card>
    </div>
  </div>
</template>
<script>
import { LoginCard } from "@/components";
export default {
  components: {
    LoginCard,
  },
  created(){
    this.$root.state.apiurl = "";
  },
  data() {
    return {
      firstname: "",
      password: "",
    };
  },
  methods: {
    submit (){
      this.$api.login({
        user_id : this.firstname,
        user_password : this.password
      })
        .then(this.$Then(res => {
          if(res.code === 512){
            this.$errorMsg(this.$I18n("http_error_514_2"));
            return
          }else if(res.code === 406){
            this.$errorMsg(this.$I18n("error_code_406_1"));
            return
          }
          localStorage.acc_token = res.data.acc_token;
          this.$api.userInfo()
            .then(this.$Then(res => {
              this.$setUserInfo(res.data)
              this.$successMsg(this.$I18n("login_success"))
              setTimeout(() => {
                this.$router.push({
                  query: { ...this.$router.history.current.query },
                  path: "/"
                })
              } , 1000)
            }))
            .catch(this.$Catch())
        }, [512, 406]))
        .catch (err => {
          if(err.code){
            return
          }
          this.$errorMsg(this.$I18n("http_error_514"))
        })
    },
  },
};
</script>

<style type="scss" scoped>
  .diy-submit{
    width: 90%;
  }
  .md-form-group{
    margin-top: 30px;
    margin-bottom: 20px;
  }
</style>
